import { useState, useRef, useEffect } from 'react';
import TencentFilter from './tencentfilter';
import VideoScreenshotCapture from './videoscreenshotcapture';

/*
 * Thing that wires together TencentFilter, webcam input, and VideoScreenshotCapture,
 * as well as fetching authentication ...
 */
// Defaults to "" so the CRA dev proxy serves same-origin /api requests locally.
// Override with REACT_APP_API_BASE for non-proxied deployments.
const API_BASE = process.env.REACT_APP_API_BASE || ""

const FilterContainer = ({ beauty = {}, webcamConstraints = {}, screenshotFunctionRef, licenseUrl = API_BASE + "/api/tencent/tencent-license", signatureUrl = API_BASE + "/api/tencent/tencent-signature" }) => {
  const [authn, setAuthn] = useState(null);
  const [input, setInput] = useState(null);
  const [licenseFetchError, setLicenseFetchError] = useState(null);
  const theVideo = useRef(null);

  useEffect(() => {
    let ignore = false;
    // Track the stream this effect actually acquired so cleanup stops THIS stream,
    // not whatever is in `input` state. Keeping acquisition and teardown in one
    // effect is what makes StrictMode's mount/cleanup/mount cycle safe: the torn-down
    // stream is stopped and a fresh one replaces it, instead of the live feed's tracks
    // being killed by a separate [input] effect.
    let localStream = null;

    // Fetch license keys
    // TODO: Should TencentFilter just take a URL (or a 'base' URL that gets preset endpoint names appended to it for license and signature) as to
    // consolidate everything that fetches from URL in one place?
    fetch(licenseUrl).then(res => {
      res.json().then((res) => { if (!ignore) setAuthn(res) }, rejectReason => {
        if (!ignore) setLicenseFetchError("json(): " + JSON.stringify(rejectReason));
      });
    }, rejectReason => {
      if (!ignore) setLicenseFetchError("fetch(): " + JSON.stringify(rejectReason));
    });

    // Get webcam input
    // TODO handle if there's an error or we never get the stream --- in final version, we may want to set something that stops the user from continuing with the study if this happens?
    // Possibly a retry mechanism? That might be more of a stretch goal though
    navigator.mediaDevices.getUserMedia(webcamConstraints)
      .then(stream => {
        if (ignore) {
          // Effect was torn down before the stream arrived; stop it immediately.
          stream.getTracks().forEach((track) => track.stop());
          return;
        }
        localStream = stream;
        setInput(stream);
      }, rejectReason => {
        console.error("getMediaStream failed", rejectReason);
      });

    // Stop the webcam feed on unmount / before re-running. Only stops the stream this
    // effect acquired, and does not touch state (no setInput here).
    return () => {
      ignore = true;
      if (localStream) {
        localStream.getTracks().forEach((track) => track.stop());
      }
    };
  }, [licenseUrl, webcamConstraints]);

  console.log("Tencent container states: ", licenseFetchError, authn);

  let tencent = <span>Loading...</span>;
  if (licenseFetchError != null) {
    tencent = <span>Error fetching keys needed to start Tencent filter:  {JSON.stringify(licenseFetchError)}</span>
  } else if (authn !== null) {
    console.log("Starting filter with ref", theVideo);
    tencent = <TencentFilter appId={authn.appid || null} licenseKey={authn.key || null} authUrl={signatureUrl} input={input} beautyParams={beauty} outputVideoRef={theVideo} />;
  }

  return (<>
    <video ref={theVideo}/>
    <VideoScreenshotCapture videoRef={theVideo} screenshotFunctionRef={screenshotFunctionRef}/>
    {tencent}
  </>);
}

export default FilterContainer;